import { useMutation, useQueryClient } from "@tanstack/react-query";
import { resetTemporalBillets } from "../repositories/MillSetupRepository";

interface UseResetTemporalBilletsOptions {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
}

export const useResetTemporalBillets = ({
	onSuccess,
	onError,
}: UseResetTemporalBilletsOptions = {}) => {
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationFn: resetTemporalBillets,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["millSetup", "campaign"] });
			onSuccess?.();
		},
		onError: (error: Error) => {
			onError?.(error);
		},
	});

	return {
		resetTemporalBillets: mutation.mutate,
		isResetting: mutation.isPending,
	};
};
